var map = {
	"./MGLogo.svg": 24572,
	"./TrueLayer.svg": 80260,
	"./Vouchers.png": 40174,
	"./amex.svg": 66032,
	"./bankofscotland.svg": 51876,
	"./barclays.svg": 13826,
	"./capitalone.svg": 78037,
	"./firstdirect.svg": 8894,
	"./halifax.svg": 79394,
	"./hsbc.svg": 39115,
	"./lloyds.svg": 28606,
	"./mbna.svg": 7015,
	"./metro.svg": 31752,
	"./monese.svg": 48218,
	"./monzo.svg": 39384,
	"./ms.svg": 4053,
	"./nationwide.svg": 72429,
	"./natwest.svg": 4967,
	"./paragon.svg": 99209,
	"./revolut.svg": 83558,
	"./santander.svg": 8003,
	"./starling.svg": 59817,
	"./temp_charliehr.png": 22936,
	"./temp_charliehr.svg": 80498,
	"./temp_peoplepension.png": 62601,
	"./temp_peoplepension.svg": 18079,
	"./temp_shopst.png": 43851,
	"./temp_shopst.svg": 8059,
	"./temp_unum.png": 77085,
	"./temp_unum.svg": 95273,
	"./temp_vitality.svg": 17352,
	"./tesco.svg": 90197,
	"./tide.svg": 24761,
	"./tsb.svg": 21620,
	"./virginmoney.svg": 96158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95379;